import { INote } from "../../../../../common/types";

const getNoteLength = (note: INote) => {
    if (!note) return 0;
    let width = 4 / note.l;
    if (note.d) width *= 1.5;
    width *= note.t ? 2 : 3;
    return width;
};

export default getNoteLength;
